import React from "react";

import { Card } from "../Card";
import { UtilityText } from "../UtilityText";

import styles from "./DataTable.scss";
import type {
  MobileCardComponentProps,
  TableColumn,
  TableDataType,
} from "./types";

function renderHeader(header: TableColumn["header"]): React.ReactNode {
  if (typeof header === "function") {
    return header();
  }
  return header;
}

export function DefaultMobileCard<
  DataType extends TableDataType = TableDataType
>({ row, columns }: MobileCardComponentProps<DataType>): React.ReactElement {
  const visibleColumns = columns.filter(
    (column) => !column.isCheckBox && !column.isExpansionToggle
  );
  return (
    <Card
      className={styles["mobile-card"]}
      data-testid="data-table-mobile-card"
    >
      {visibleColumns.map((column, index) => (
        <div key={index} className={styles["mobile-card-pair"]}>
          <UtilityText size="small" className={styles["mobile-card-label"]}>
            {renderHeader(column.header)}
          </UtilityText>
          <div className={styles["mobile-card-value"]}>
            {column.renderCell(row)}
          </div>
        </div>
      ))}
    </Card>
  );
}
